import angular from 'angular';

import Component from './smartlockPanel.component';
import Service from './smartlock.service';

export default angular
  .module('petroCloud.dashboard.smartlockPanel', [])
  .component(Component.name, Component)
  .service('Smartlock', Service)
  .name;
